export default [
  {
    id: 1,
    label: "보호구",
    check: false,
    title: "보호구",
    list: [
      {
        id: 1,
        label: "보호구 착용 및 관리상태(청력, 호흡용)가 적절 한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "기타 보호구 착용 및 관리상태가 적절한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "적절한 보호구(적격품)를 지급하고 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 2,
    label: "환기 및 배기장치",
    check: false,
    title: "환기 및 배기장치",
    list: [
      {
        id: 1,
        label: "환기상태 및 환기설비 작동상태는 적절한가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "밀폐공간 주기적인 점검 및 파악(산소농도, 자연환기, 환기 사용 점검 등)",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 3,
    label: "표지",
    check: false,
    title: "표지",
    list: [
      {
        id: 1,
        label: "안전보건표지는 적절히 부착되어 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "종사자들에게 알려야 할 자료들이 눈에 띄는 곳에 게시되어 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "화학물질 취급시 MSDS 게시 및 부착의무, 작업 공정별 관리요령 게시가 이루어져 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 4,
    label: "작업자세",
    check: false,
    title: "작업자세",
    list: [
      {
        id: 1,
        label: "작업자세/동선 및 중량물 취급자세 (중량물 취급시 2인 1조 작업/ 이동보조도구 활 용 등)",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 5,
    label: "작업장",
    check: false,
    title: "작업장",
    list: [
      {
        id: 1,
        label: "작업장 내 정리정돈, 위생상태/ 소화기 유무, 관리 상태 (통로확보, 분리수거함 등)\n",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "시설물 파손여부, 청소, 점검 등 관리상태",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "인화성물질(휘발유, 등유, 경유 등)은 안전하게 관리되고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "화학물질 소분용기에 경고표지가 부착되어 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 5,
        label: "국소 배기장치 상태 및 작동, 관리는 적절한가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 6,
    label: "근로자",
    check: false,
    title: "근로자",
    list: [
      {
        id: 1,
        label: "근로자의 부상, 외상 등 조치할 수 있는 응급구급함이 갖추어져 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "근로자의 정기적인 건강진단을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "교대근무 여부",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "근로자의 질병 예방 및 사후관리 방안이 활용되 고 있는가? (휴식시간, 휴게시설, 유연근무제 등)",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 7,
    label: "교육",
    check: false,
    title: "교육",
    list: [
      {
        id: 1,
        label: "매달 정기안전보건교육을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "신규 근로자의 경우 안전보건교육을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "근로자의 특별교육 해당일 경우 이를 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "MSDS교육을 실시하고 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 8,
    label: "직업성 질환",
    check: false,
    title: "직업성 질환",
    list: [
      {
        id: 1,
        label: "하루 4시간 이상 집중적으로 자료입력 등을 위한 키보드/마우스 조작작업에 해당이 되는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        label: "하루 총 2시간 이상 쪼그리고 앉거나 무릎을 굽힌 자세의 작업에 해당이 되는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        label: "하루 총 2시간 이상 4.5kg이상의 물건을 한 손으 로 들거나 동일한 힘으로 쥐는 작업에 해당이 되는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        label: "5kg이상 중량물 취급 시 중량물 취급안내표시가 부착되어있는가?",
        is_checked: "",
        note: "",
      },
      {
        id: 5,
        label: "근무시 기타 질환 유발요인들이 있는가?",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 9,
    label: "휴게시설",
    check: false,
    title: "휴게시설",
    list: [
      {
        id: "1-a",
        title: "산업안전보건법상 휴게시설 설치",
        label: "산업안전보건법 제128조의2에 따른 휴게시설 설치 여부",
        is_checked: "",
        note: "",
      },
      {
        id: "2-a",
        title: "최소 바닥면적과 천장까지의 높이",
        label: "최소 바닥면적 6㎡ 이상, 바닥면에서 천장까지 높이 2.1m 이상",
        is_checked: "",
        note: "",
      },
      {
        id: "2-b",
        title: "최소 바닥면적과 천장까지의 높이",
        label: "동시 사용인원 등을 고려하여 근로자대표와 협의하여 정하였는지 여부",
        is_checked: "",
        note: "",
      },
      {
        id: "3-a",
        title: "이용하기 편리하고 안전한 곳에 설치",
        label: "휴식시간에 이용하기 편리하고 가까운 곳에 설치\n" + "* 작업장소에서 휴게시설까지의 왕복 이동에 걸리는 시간이 휴게시간의 20%를 넘지 않는 곳에 위치",
        is_checked: "",
        note: "",
      },
      {
        id: "3-b",
        title: "이용하기 편리하고 안전한 곳에 설치",
        label: "화재폭발, 유해물질, 분진 및 소음 노출장소에서 떨어진 곳에 설치",
        is_checked: "",
        note: "",
      },
      {
        id: "4-a",
        title: "온도/습도/조명/환기 적정 기준 준수",
        label: "적정온도(18~28도) 유지할 수 있는 냉난방 기능 설치",
        is_checked: "",
        note: "",
      },
      {
        id: "4-b",
        title: "온도/습도/조명/환기 적정 기준 준수",
        label: "적정습도(50~55%) 유지할 수 있는 습도 조절 기능 설치",
        is_checked: "",
        note: "",
      },
      {
        id: "4-c",
        title: "온도/습도/조명/환기 적정 기준 준수",
        label: "적정 조도(100~200럭스) 유지할 수 있는 조명 조절 기능 설치",
        is_checked: "",
        note: "",
      },
      {
        id: "4-d",
        title: "온도/습도/조명/환기 적정 기준 준수",
        label: "창문 등을 통해 환기를 시킬 수 있는지 여부",
        is_checked: "",
        note: "",
      },
      {
        id: "5-a",
        title: "비품 구비 및 관리",
        label: "의자 등 휴식에 필요한 비품 구비",
        is_checked: "",
        note: "",
      },
      {
        id: "5-b",
        title: "비품 구비 및 관리",
        label: "마실 수 있는 물이나 식수 설비 구비",
        is_checked: "",
        note: "",
      },
      {
        id: "5-c",
        title: "비품 구비 및 관리",
        label: "휴게시설을 알아볼 수 있는 표지를 외부에 부착",
        is_checked: "",
        note: "",
      },
      {
        id: "5-d",
        title: "비품 구비 및 관리",
        label: "관리 담당자 지정",
        is_checked: "",
        note: "",
      },
      {
        id: "6-a",
        title: "목적 외 사용금지",
        label: "휴게시설 목적 외의 용도로 사용 금지",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 10,
    label: "온열질환",
    check: false,
    title: "온열질환",
    list: [
      {
        id: "1-a",
        title: "(물) 시원한 물 자주 마시기",
        label: "시원하고 깨끗한 물 충분히 제공",
        is_checked: "",
        note: "",
      },
      {
        id: "2-a",
        title: "(냉방장치) 실내 옥외 작업장 온도 낮추기",
        label: "폭염작업시 (이동식)에어컨, 산업용 선풍기 등 냉방·통풍장치 및 그늘막 설치",
        is_checked: "",
        note: "",
      },
      {
        id: "2-b",
        title: "(냉방장치) 실내 옥외 작업장 온도 낮추기",
        label: "작업시간대 조정 등 폭염 집중 시간대 노출 최소화",
        is_checked: "",
        note: "",
      },
      {
        id: "3-a",
        title: "(휴식) 주기적으로 쉬기",
        label: "체감온도 31℃ 이상 폭염작업 시 적절한 휴식",
        is_checked: "",
        note: "",
      },
      {
        id: "3-b",
        title: "(휴식) 주기적으로 쉬기",
        label: "체감온도 33℃ 이상 폭염작업 시 매 2시간 이내 20분 이상 휴식",
        is_checked: "",
        note: "",
      },

      {
        id: "4-a",
        title: "(보냉장구) 근로자 체온 낮추기",
        label: "냉각의류, 냉각조끼 등 개인 보냉장구 지급",
        is_checked: "",
        note: "",
      },
      {
        id: "5-a",
        title: "(119신고) 응급조치 및 119신고",
        label: "온열질환자·의심자가 의식이 없는 경우 즉시 119에 신고",
        is_checked: "",
        note: "",
      },
      {
        id: "5-b",
        title: "(119신고) 응급조치 및 119신고",
        label: "의식이 있는 경우 응급조치 후 증상 개선 없을 시 119 신고",
        is_checked: "",
        note: "",
      },
      {
        id: "6-a",
        title: "그 외 예방조치",
        label: "작업장소에 온·습도계 비치하여 체감온도 측정 및 조치사항 기록",
        is_checked: "",
        note: "",
      },
      {
        id: "6-b",
        title: "그 외 예방조치",
        label: "폭염작업전 온열질환 증상 및 응급조치 요령 알리기",
        is_checked: "",
        note: "",
      },
      {
        id: "6-c",
        title: "그 외 예방조치",
        label: "온열질환 예방수칙, 사고사례, 자각증상 진단표 등 게시",
        is_checked: "",
        note: "",
      },
      {
        id: "6-d",
        title: "그 외 예방조치",
        label: "작업장소와 가까운 곳에 휴게시설(쉼터 및 그늘진 장소) 설치",
        is_checked: "",
        note: "",
      },
      {
        id: "6-e",
        title: "그 외 예방조치",
        label: "휴식시간 추가 배정 등 온열질환 민감군 관리, 폭염작업 시간 단축",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 11,
    label: "한랭질환",
    check: false,
    title: "한랭질환",
    list: [
      {
        id: 1,
        title: "따뜻한 옷 (방한구)",
        label: "여러 겹의 옷, 방한모, 장갑 착용",
        is_checked: "",
        note: "",
      },
      {
        id: 2,
        title: "따뜻한 옷 (방한구)",
        label: "보온 장갑 및 보온·방수기능 신발 착용",
        is_checked: "",
        note: "",
      },
      {
        id: 3,
        title: "따뜻한 물",
        label: "따뜻하고 깨끗한 물 제공",
        is_checked: "",
        note: "",
      },
      {
        id: 4,
        title: "따뜻한 쉼터",
        label: "(휴게시설) 휴식시간에 이용할 수 있는 휴게시설 설치",
        is_checked: "",
        note: "",
      },
      {
        id: 5,
        title: "따뜻한 쉼터",
        label: "(휴게시설) 휴게시설 크기, 온도, 위치 등 적정기준 준수 여부 확인",
        is_checked: "",
        note: "",
      },
      {
        id: 6,
        title: "따뜻한 쉼터",
        label: "(쉼터) 휴게시설 설치장소 이외 작업장소와 가까운 곳에 추위를 피할 수 있는 따뜻한 쉼터 마련<br/>- 난방장치 설치 시 화재 또는 유해가스 중독 우려가 없도록 설치",
        is_checked: "",
        note: "",
      },
      {
        id: 7,
        title: "따뜻한 쉼터",
        label: "(쉼터) 한파특보 발령시 적절하게 휴식 부여",
        is_checked: "",
        note: "",
      },
      {
        id: 8,
        title: "작업시간대 조정",
        label: "한파특보(주의보) 발령 시 작업시간대 조정 또는 작업시간 단축",
        is_checked: "",
        note: "",
      },
      {
        id: 9,
        title: "작업시간대 조정",
        label: "한파특보(경보) 발령 시 추운시간대(새벽) 옥외 작업중지 또는 최소화",
        is_checked: "",
        note: "",
      },
      {
        id: 10,
        title: "응급조치",
        label: "야외 작업자의 한랭질환 의심자 발생시 즉시 119 신고",
        is_checked: "",
        note: "",
      },
      {
        id: 11,
        title: "응급조치",
        label: "근로자에게 한랭질환 예방·응급조치 교육 실시",
        is_checked: "",
        note: "",
      },
      {
        id: 12,
        title: "기타",
        label: "한랭질환 예방가이드와 자율점검표를 근로자가 쉽게 볼 수 있는 위치에 게시",
        is_checked: "",
        note: "",
      },
      {
        id: 13,
        title: "기타",
        label: "운동지도 및 민감군 사전관리<br/>* (민감군) 고혈압, 당뇨, 뇌심혈관질환, 갑상선 기능저하, 허약체질, 고령자, 신규배치자 등",
        is_checked: "",
        note: "",
      },
    ],
  },
  {
    id: 12,
    label: "밀폐공간",
    check: false,
    title: "밀폐공간",
    list: [
      {
        id: 1,
        title: "밀폐공간작업 프로그램 수립·시행(제619조 제3항)",
        content: "사업장 내 밀폐공간 위치 및 해당 공간 내 위험성* 파악 여부\n" + "* 산소결핍, 황화수소, 일산화탄소, 아르곤 등",
        isChecked: "",
      },
      {
        id: 2,
        title: "밀폐공간작업 프로그램 수립·시행(제619조 제3항)",
        content: "사업주 또는 관리책임자가 유해가스 농도 및 환기상태 등 작업장 상황을 확인 후 작업을 허가하는 내부규정(절차)이 마련되어 있는지 여부",
        isChecked: "",
      },
      {
        id: 3,
        title: "출입금지조치(제622조)",
        content: "출입금지조치(제622조)",
        isChecked: "",
      },
      {
        id: 4,
        title: "출입금지조치(제622조)",
        content: "시건조치(잠금장치) 여부",
        isChecked: "",
      },
      {
        id: 5,
        title: "안전보건조치(제619조의 2~제620조)",
        content: "밀폐공간 작업 전, 작업 중 산소 및 유해가스 농도측정 및 적정공기 상태 확인 여부\n" + "※ ① 산 소 : 18.0 ~ 23.5%\n" + " ② 황화수소 : 10 ppm 미만\n" + " ③ 탄산가스(이산화탄소) : 1.5% 미만\n" + " ④ 일산화탄소 : 30 ppm미만",
        isChecked: "",
      },
      {
        id: 15,
        title: "안전보건조치(제619조의 2~제620조)",
        content: "밀폐공간 산소 및 유해가스 농도 측정 결과 보존 여부",
        isChecked: "",
      },
      {
        id: 6,
        title: "안전보건조치(제619조의 2~제620조)",
        content: "밀폐공간 작업 전, 작업 중 환기팬을 이용한 환기 여부",
        isChecked: "",
      },
      {
        id: 7,
        title: "안전보건조치(제619조의 2~제620조)",
        content: "적정공기가 아닌 상태에서 작업 시 송기마스크나 공기호흡기 사용 여부",
        isChecked: "",
      },
      {
        id: 8,
        title: "인원의 점검(제621조)",
        content: "밀폐공간 작업 시 입·출입 근로자 인원 점검 여부",
        isChecked: "",
      },
      {
        id: 9,
        title: "감시인 배치(제623조)",
        content: "밀폐공간 작업 시 감시인 배치 여부",
        isChecked: "",
      },
      {
        id: 10,
        title: "대피용 기구의 비치(제625조)",
        content: "송기마스크(또는 공기호흡기) 비치 여부 확인",
        isChecked: "",
      },
      {
        id: 11,
        title: "안전한 작업 방법 교육(제641조)",
        content: "밀폐공간 작업 전 작업자와 감시인에게 안전하게 작업하는 방법을 주지하는지 여부\n" + "※ 유해가스 측정, 환기설비 가동, 보호구 착용, 사고시 응급조치, 구조요청 절차 등",
        isChecked: "",
      },
      {
        id: 12,
        title: "필수장비 지급 확인",
        content: "산소 및 유해가스 측정기",
        isChecked: "",
      },
      {
        id: 13,
        title: "필수장비 지급 확인",
        content: "환기설비(송풍기 등), 발전기(또는 배터리)",
        isChecked: "",
      },
      {
        id: 14,
        title: "필수장비 지급 확인",
        content: "송기마스크 또는 공기호흡기",
        isChecked: "",
      },
    ],
  },
  {
    id: 13,
    label: "MSDS",
    check: false,
    title: "MSDS",
    list: [
      {
        id: 1,
        title: "MSDS 게시 (법 제114조 제1항)",
        content:
          "작업장에 MSDS를 적절한 장소에 게시·비치하였는가?\n\n" +
          "※ MSDS 게시장소 (택 1)\n" +
          " ① 대상물질을 취급하는 작업공정이 있는 장소\n" +
          " ② 작업장 내 근로자가 가장 보기 쉬운 장소\n" +
          " ③ 근로자가 작업 중 쉽게 접근할 수 있는 전산장비",
        isChecked: "",
      },
      {
        id: 2,
        title: "MSDS 교육 (법 제114조제3항)",
        content:
          "취급근로자에게 MSDS 교육(1시간)을 실시하였는가?\n\n" +
          "※ ① 화학물질을 제조·사용·운반·저장하는 작업에 근로자를 신규로 배치하게 된 경우,\n" +
          "&nbsp;&nbsp;&nbsp; ② 새로운 화학물질이 도입된 경우, \n" +
          "&nbsp;&nbsp;&nbsp; ③ 유해·위험성 정보가 변경된 경우 실시",
        isChecked: "",
      },
      {
        id: 3,
        title: "MSDS 교육 (법 제114조제3항)",
        content: "MSDS 교육내용은 아래의 내용을 모두 포함하였는가?\n\n" + "※ 화학물질의 명칭 또는 제품명, 물리적 위험성 및 건강 유해성, 취급상의 주의사항, 적절한 보호구, 응급조치요령, 사고 시 대처방법, MSDS 및 경고표지의 이해방법",
        isChecked: "",
      },
      {
        id: 4,
        title: "MSDS 교육 (법 제114조제3항)",
        content: "MSDS 교육시간 및 내용을 기록하고 보존하였는가?",
        isChecked: "",
      },
      {
        id: 5,
        title: "경고표지 (법 제115조)",
        content: "화학물질을 담은 소분용기에 경고표지를 부착하였는가?",
        isChecked: "",
      },
      {
        id: 6,
        title: "경고표지 (법 제115조)",
        content: "경고표지 기재내용은 아래 내용을 모두 포함하였는가?\n\n" + "※ 명칭, 그림문자, 신호어, 유해‧위험성 문구, 예방조치 문구, 공급자 정보",
        isChecked: "",
      },
      {
        id: 7,
        title: "특별관리물질관리 (안전보건규칙 제439조)",
        content: "특별관리물질 고지를 적절한 장소에 게시 하였는가?",
        isChecked: "",
      },
      {
        id: 8,
        title: "특별관리물질관리 (안전보건규칙 제439조)",
        content: "취급근로자에게 특별교육(16시간)을 실시하였는가?",
        isChecked: "",
      },
      {
        id: 9,
        title: "특별관리물질관리 (안전보건규칙 제439조)",
        content: "특별관리물질 사용시 취급일지를 적절하게 작성하였는가?",
        isChecked: "",
      },
    ],
  },
];
